const Typography = (theme, borderRadius, fontFamily) => ({
  fontFamily,
  h6: {
    fontWeight: 400, // Reducido de 500 para más minimalismo
    color: theme.palette.grey[700], // Color más suave
    fontSize: "0.9rem",
    letterSpacing: "0.02em", // Espaciado más amplio
  },
  h5: {
    fontSize: "1rem",
    color: theme.palette.grey[700],
    fontWeight: 400, // Reducido de 500
    letterSpacing: "0.02em",
  },
  h4: {
    fontSize: "1.15rem",
    color: theme.palette.grey[800], // Más oscuro pero no tanto
    fontWeight: 500, // Reducido de 600
    letterSpacing: "0.01em",
  },
  h3: {
    fontSize: "1.4rem",
    color: theme.palette.grey[800],
    fontWeight: 500, // Reducido de 600
    letterSpacing: "0.01em",
  },
  h2: {
    fontSize: "1.75rem",
    color: theme.palette.grey[900],
    fontWeight: 600, // Reducido de 700
    letterSpacing: "0.005em",
  },
  h1: {
    fontSize: "2.5rem",
    color: theme.palette.grey[900],
    fontWeight: 600, // Reducido de 700
    letterSpacing: "-0.01em", // Espaciado negativo para tamaños grandes
  },
  subtitle1: {
    fontSize: "1rem",
    fontWeight: 500,
    color: theme.palette.text.dark,
  },
  subtitle2: {
    fontSize: "0.9rem",
    fontWeight: 400,
    color: theme.palette.text.secondary,
  },
  caption: {
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
    fontWeight: 400,
  },
  body1: {
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "1.334em",
  },
  body2: {
    letterSpacing: "0em",
    fontWeight: 400,
    lineHeight: "1.5em",
    color: theme.palette.text.primary,
  },
  button: {
    textTransform: "capitalize",
  },
  customInput: {
    marginTop: 1,
    marginBottom: 1,
    "& > label": {
      top: 23,
      left: 0,
      color: theme.palette.grey[500],
      '&[data-shrink="false"]': {
        top: 5,
      },
    },
    "& > div > input": {
      padding: "30.5px 14px 11.5px !important",
    },
    "& legend": {
      display: "none",
    },
    "& fieldset": {
      top: 0,
    },
  },
  mainContent: {
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.dark[800] : theme.palette.primary.light,
    width: "100%",
    minHeight: "calc(100vh - 110px)",
    flexGrow: 1,
    padding: "20px",
    marginTop: "110px",
    marginRight: "20px",
    borderRadius: `${borderRadius}px`,
  },
  menuCaption: {
    fontSize: "1rem",
    fontWeight: 500,
    color: theme.palette.grey[600],
    padding: "6px",
    textTransform: "capitalize",
    marginTop: "10px",
  },
  subMenuCaption: {
    fontSize: "0.8rem",
    fontWeight: 500,
    color: theme.palette.text.secondary,
    textTransform: "capitalize",
  },
  commonAvatar: {
    cursor: "pointer",
    borderRadius: "16px",
  },
  smallAvatar: {
    width: "22px",
    height: "22px",
    fontSize: "1.1rem",
  },
  mediumAvatar: {
    width: "34px",
    height: "34px",
    fontSize: "1.4rem",
  },
  largeAvatar: {
    width: "44px",
    height: "44px",
    fontSize: "1.7rem",
  },
});

export default Typography;
